import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { Loader } from "../Loader"
import { NumberManagementAdmin } from "./NumberManagementAdmin"
import { NumberManagementIndividual } from "./NumberManagementIndividual"
import { useUserData } from "../../lib/redux/users/user-data-hook"
import { reloadCnamRegistrations, reloadPhoneNumbers } from "../../lib/redux/users/slice"
import { clearCache, SERVICE_CALLS } from "../../extension-helpers"


function NumberRegistration() {
    const dispatch = useDispatch()
    const { isAdmin, user } = useUserData()

    useEffect(() => {
        clearCache(SERVICE_CALLS.PARALLEL_SETTINGS)
        clearCache(SERVICE_CALLS.AUTODIALER_INFO)
        clearCache(SERVICE_CALLS.USER_INFO)

        // Load CNAM registrations and phone numbers if user exists
        if (user?.team_id && user?.user_id && isAdmin !== null) {
            reloadCnamRegistrations(dispatch, user.team_id)
            reloadPhoneNumbers(dispatch, user.user_id, isAdmin)
        }
    }, [user?.team_id, user?.user_id, isAdmin, dispatch]);

    if (isAdmin === null) return <Loader />
    return isAdmin ? <NumberManagementAdmin /> : <NumberManagementIndividual />
}

export { NumberRegistration }
  